export default __webpack_public_path__ + "static/media/Github-logo2.abad4008.png";